import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { Callout } from '@bingads-webui-react/callout';

export const withPopover = (WrappedComponent) => {
  const HOC = (props) => {
    const {
      show,
      onClose,
      classes,
      children,
      id,
      placement,
      closeButton,
      title,
      popoverClassName,
      container,
      focusLockContent,
    } = props;

    return (
      <Callout
        content={<WrappedComponent {...props} />}
        placement={placement}
        popoverId={id}
        show={show}
        classes={classes}
        onClose={onClose}
        closeButton={closeButton}
        title={title}
        popoverClassName={popoverClassName}
        container={container}
        focusLockContent={focusLockContent}
      >
        {children}
      </Callout>
    );
  };

  HOC.displayName = `withPopover(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  HOC.defaultProps = {
    classes: {},
    id: 'pop-over',
    placement: 'bottom',
    closeButton: false,
    title: null,
    onClose: null,
    show: null,
    popoverClassName: null,
    container: null,
    focusLockContent: true,
  };

  HOC.propTypes = {
    children: PropTypes.element.isRequired,
    onClose: PropTypes.func,
    show: PropTypes.bool,
    classes: PropTypes.shape({}),
    id: PropTypes.string,
    placement: PropTypes.string,
    closeButton: PropTypes.bool,
    title: PropTypes.string,
    popoverClassName: PropTypes.string,
    container: PropTypes.shape(),
    focusLockContent: PropTypes.bool,
  };

  return HOC;
};
